import { createRouter, createWebHistory } from 'vue-router'
import Collection from '@/views/finance/collection.vue'
import Payment from '@/views/finance/payment.vue'
import Detail from '@/views/finance/detail.vue'
import Examinelist from '@/views/sale/examinelist.vue'
import Supplypay from '@/views/finance/supplypay.vue'

const routes = [
  {
    path: '/collection',
    name: 'collection',
    component: Collection
  },
  {
    path: '/detail',
    name: 'detail',
    component: Detail
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment
  },
  {
    path: '/examinelist',
    name: 'examinelist',
    component: Examinelist
  },
  {
    path: '/supplypay',
    name: 'supplypay',
    component: Supplypay
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
